import {Modal} from 'bootstrap';
import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {PermissionsService} from '../../../../Services/permissions.service';

@Component({
  selector: 'app-modal-entity-history',
  templateUrl: './modal-entity-history.component.html',
  styleUrls: ['./modal-entity-history.component.css'],
  standalone: false
})
export class ModalEntityHistoryComponent implements OnInit, OnDestroy {
  @ViewChild('closeButton') closeButton: ElementRef;

  @Input() vm: any;
  searchReceivablePayments;
  searchReceivableInvoices;

  constructor(private permissionsService: PermissionsService) {
  }

  get hasReceivablePaymentPermission(): boolean {
    return this.permissionsService.Get('Admin') ||
      this.permissionsService.Get('EditReceivablePayments') ||
      this.permissionsService.Get('ViewReceivablePayments');
  }

  get hasReceivableInvoicePermission(): boolean {
    return this.permissionsService.Get('Admin') ||
      this.permissionsService.Get('EditReceivableInvoices') ||
      this.permissionsService.Get('ViewReceivableInvoices');
  }

  get hasPayableInvoicePermission(): boolean {
    return this.permissionsService.Get('Admin') ||
      this.permissionsService.Get('EditPayableInvoices') ||
      this.permissionsService.Get('ViewPayableInvoices');
  }

  get hasPayablePaymentPermission(): boolean {
    return this.permissionsService.Get('Admin') ||
      this.permissionsService.Get('EditPayablePayments') ||
      this.permissionsService.Get('ViewPayablePayments');
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    const modalEl = this.closeButton?.nativeElement?.closest('.modal');
    if (modalEl) {
      const modal = Modal.getInstance(modalEl);
      if (modal) {
        modal.hide();
      }
    }
  }

}
